import { observer } from "mobx-react";
import { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { RootStoreContext } from "../../../stores/RootStore";
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

interface ConfirmButtonProps {
  hasRentalSelected?: boolean;
  onRentalConfirm?: () => void;
  disabled?: boolean;
}

const ConfirmButton = observer(({ hasRentalSelected = false, onRentalConfirm, disabled = false }: ConfirmButtonProps = {}) => {
  const {
    registrationStore: { hasPreselectedItems, selectSellingItems },
  } = useContext(RootStoreContext);

  const hasItems = hasPreselectedItems || hasRentalSelected;
  const isDisabled = disabled || !hasItems;
  const handleClick = hasRentalSelected && onRentalConfirm ? onRentalConfirm : selectSellingItems;

  return (
    <Row className="confirm-button-container">
      <Col xs={12} className="text-center">
        <button
          className={`action-button confirm ${isDisabled ? "disabled" : ""}`}
          disabled={isDisabled}
          onClick={handleClick}
        >
          <div className="button-content">
            <FontAwesomeIcon icon={faCheck} className="button-icon" />
            <span className="button-text">Confirm Selected</span>
          </div>
        </button>
      </Col>
    </Row>
  );
});

export default ConfirmButton;
